import type { ColumnDef } from "@tanstack/react-table";
import type { ApReceipt } from "@/accounts-payable/types";
import { formatApDate } from "@/accounts-payable/utils";

export const dateCol: ColumnDef<ApReceipt> = {
  accessorKey: "receipt_date",
  header: "Purchased",
  meta: { size: "120px" },
  cell: ({ row }) => <span>{formatApDate(row.original.receipt_date)}</span>,
};
